'use client'

import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'
import { commonStyles } from '@/lib/theme-utils'

interface GlobalLoadingProps {
  message?: string
}

export function GlobalLoading({ message = "Carregando..." }: GlobalLoadingProps) {
  return (
    <div className="fixed inset-0 z-[60] h-screen w-screen overflow-hidden bg-card/95 backdrop-blur-sm">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_1px_1px,rgba(0,0,0,0.02)_1px,transparent_0)] [background-size:32px_32px] dark:bg-[radial-gradient(circle_at_1px_1px,rgba(255,255,255,0.02)_1px,transparent_0)]" />
      
      <div className="relative flex items-center justify-center h-full w-full">
        <div className="flex flex-col items-center space-y-6">
          
          {/* Minimalist spinner following frontend-complete rules */}
          <div className={cn(
            commonStyles.iconContainer.lg,
            "bg-gradient-to-br from-primary to-primary/90",
            "ring-1 ring-primary/20",
            "shadow-lg shadow-primary/20",
            "transition-all duration-200"
          )}>
            <Loader2 className={cn(
              commonStyles.icon.lg,
              "text-white animate-spin"
            )} />
          </div>
          
          {/* Minimalist branding */}
          <p className={cn(
            commonStyles.text.subtitle,
            "text-muted-foreground"
          )}>
            Kess System
          </p>
        </div>
      </div>
    </div>
  )
}